var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.show)?_c('div',{staticClass:"block absolute px-12 py-6 top-0 right-0 text-xl text-white z-40 m-4 rounded-md",class:_vm.color},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }